const pattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

export const formEmailPattern = {
  pattern: {
    value: pattern,
    message: 'E-mail inválido',
  },
};
